<template>
  <div>
    <div class="columns" v-if="editableFeed">
      <div class="column">
        <!-- name -->
        <div class="field">
          <label class="label">
            <b-tooltip position="is-right" label="Name of the feed" dashed type="is-dark">Name</b-tooltip>
          </label>
          <div class="control">
            <input class="input" type="text" v-model="editableFeed.name">
          </div>
        </div>
        <!-- slug -->
        <div class="field">
          <label class="label">
            <b-tooltip
              position="is-right"
              label="Slug of the feed used for data retrieval"
              dashed
              type="is-dark"
            >Slug</b-tooltip>
          </label>
          <div class="control">
            <input class="input" type="text" v-model="editableFeed.slug">
          </div>
        </div>
      </div>
      <div class="column">
        <!-- enabled -->
        <div class="field">
          <label class="label">
            <b-tooltip
              position="is-right"
              label="If enabled the feed will import data"
              dashed
              type="is-dark"
            >Enabled</b-tooltip>
          </label>
          <b-switch v-model="editableFeed.enabled" type="is-success"></b-switch>
        </div>
        <!-- live scored -->
        <div class="field">
          <label class="label">
            <b-tooltip
              position="is-right"
              label="Enabled if the feed receives live sport data"
              dashed
              type="is-dark"
            >Live Scored</b-tooltip>
          </label>
          <b-switch v-model="editableFeed.live_scored" type="is-success"></b-switch>
        </div>
        <!-- restricted -->
        <div class="field">
          <label class="label">
            <b-tooltip position="is-right" label="If enabled the videos of the feed will require a DStv connect login to be viewed" dashed type="is-dark">Restricted</b-tooltip>
          </label>
          <b-switch v-model="editableFeed.restricted" type="is-success"></b-switch>
        </div>
        <!-- hide from today -->
        <div class="field">
          <label class="label">
            <b-tooltip position="is-right" label="If enabled the fixtures of this feed will be hidden from the today widget on the SS homepage" dashed type="is-dark">Hide From Today</b-tooltip>
          </label>
          <b-switch v-model="editableFeed.hide_from_today" type="is-success"></b-switch>
        </div>
        <!-- save button -->
        <div class="field">
          <button @click="updateFeed" class="button is-primary">Update Details</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { SET_FEED } from "@/store/mutations";
import { GET_FEED, UPDATE_FEED } from "@/store/actions";

export default {
  name: "feed-settings",
  components: {
    Loading
  },
  data() {
    return {
      editableFeed: null
    };
  },
  mounted() {
    if (this.feed) {
      this.editableFeed = { ...this.feed };
    }
  },
  computed: {
    feed() {
      return this.$store.state.feed.item;
    }
  },
  watch: {
    feed() {
      if (this.feed) {
        this.editableFeed = { ...this.feed };
      }
    }
  },
  methods: {
    updateFeed() {
      this.$store.dispatch(UPDATE_FEED, this.editableFeed);
    }
  }
};
</script>
